export const showQR = ()=>{
    document.querySelector(".landing img").classList.add("d-none")
    document.querySelector(".landing .buttons-container").classList.add("d-none")
    document.querySelector(".App").classList.remove("d-none")
}

export const showManual = ()=>{
    document.querySelector(".landing img").classList.add("d-none")
    document.querySelector(".landing .buttons-container").classList.add("d-none")
    document.querySelector(".manual-register").classList.remove("d-none")
}

const base = window.location.hostname === "localhost"
    ? "http://127.0.0.1:8000"
    : "https://savethechildrenmx.org";

export const getPayments = async ()=>{
    await fetch(`${base}/api/event/2/getPayments`, {
        method: "GET",
    }).then(response => response.json()).then(responseJson => {
        responseJson.forEach((item) => {
            console.log(item);
            var container = document.createElement("div");
            container.classList.add("item");

            var propietario = document.createElement("div")
            propietario.innerHTML = item.comprador

            var mesa = document.createElement("div")
            mesa.textContent = "Mesa " + item.event_table.name

            var asientos = document.createElement("div")
            asientos.textContent = (item.asientos - item.boletos_usados) +" asientos"

            var registrar = document.createElement("button")
            registrar.textContent = "Registrar"
            registrar.setAttribute("payment",item.id);
            registrar.onclick = registrarAsistencia

            container.appendChild(propietario);
            container.appendChild(mesa);
            container.appendChild(asientos);
            container.appendChild(registrar);

            document.querySelector(".list").appendChild(container);
        })
    })
}

const registrarAsistencia = async (evt)=>{
    const response = await fetch(`${base}/api/events/payment/checkin?id=${evt.target.getAttribute("payment")}`, {
        method: "GET",
    });
    const responseData = await response.json();

    if (responseData.status !== 1) {
        alert(responseData.message)
    }else{
        alert("Registro de asistencia exitoso")
    }
    document.querySelector(".list").innerHTML = "";
    document.querySelector("input").value = ""
    document.querySelector("input").focus()
    getPayments()

}

export const filter = (evt) =>{
    console.log(evt.target.value)

    document.querySelectorAll(".list .item div:first-child").forEach((item)=>{
        if(evt.target.value.length > 0){
            if (item.textContent.toUpperCase().includes(evt.target.value.toUpperCase())){
                item.parentElement.classList.remove("d-none")
            }else{
                item.parentElement.classList.add("d-none")
            }
        }else{
            item.classList.remove("d-none")
        }
    })
}